import * as tslib_1 from "tslib";
import { OnInit, Injector } from '@angular/core';
import { DashboardService } from './dashboard.service';
import { LeadsOnlineService } from '../produtos/leads/services/leads.service';
import * as toastr from 'toastr';
export class DashboardComponent {
    constructor(service, injector) {
        this.service = service;
        this.injector = injector;
        this.isleads = false;
    }
    ngOnInit() {
        this.initLeadsOnline();
    }
    initLeadsOnline() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.leadsOnlineService = this.injector.get(LeadsOnlineService);
            try {
                const response = yield this.leadsOnlineService.getOriginadorLeads();
                this.isleads = response.originadorLeads;
            }
            catch (e) {
                toastr.warning('Erro ao consultar tipo de originador Leads Online. Caso seja um parceiro Leads, favor contatar o suporte', 'Atenção');
            }
        });
    }
    get hasLeads() {
        return this.isleads;
    }
}
